/**
 * Нормализует дату из любого строкового формата (ISO, RFC 2822) в YYYY-MM-DD.
 * Flask по умолчанию сериализует datetime.date в RFC 2822 ("Thu, 10 Jul 2025 00:00:00 GMT"),
 * а <input type="date"> требует YYYY-MM-DD.
 */
export function normalizeDate(value) {
  if (!value || typeof value !== 'string') return ''
  if (/^\d{4}-\d{2}-\d{2}/.test(value)) return value.slice(0, 10)
  const d = new Date(value)
  if (isNaN(d.getTime())) return ''
  const y = d.getUTCFullYear()
  const m = String(d.getUTCMonth() + 1).padStart(2, '0')
  const day = String(d.getUTCDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}
